import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { projectLocationsKeys } from '../locationsKeys'
import { RequestTypes } from '../requestTypes'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useDisableProjectLocation = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['disableProjectLocation']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...projectLocationsKeys.disableProjectLocation,
    retry: 0,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: projectLocationsKeys._def })
    },
    ...options,
  })
}
